// src/components/BagTag.js
import React, { useState } from "react";
import { TextField } from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase-config";

const BagTag = ({ value, onChange }) => {
  const { user } = useAuth();
  const [bagTag, setBagTag] = useState(value || "");
  const [error, setError] = useState("");

  // Regex allowing only letters, numbers, underscores, and periods.
  const bagTagRegex = /^[a-zA-Z0-9_.]+$/;

  const handleBlur = async () => {
    const trimmedTag = bagTag.trim();

    // If the field is empty, clear error and update.
    if (!trimmedTag) {
      setError("");
      onChange(trimmedTag);
      return;
    }

    // Validate bag tag against regex.
    if (!bagTagRegex.test(trimmedTag)) {
      setError(
        "Invalid Bag Tag. Only letters, numbers, underscores, and periods are allowed (no spaces)."
      );
      return;
    }

    try {
      // Query Firestore for any users with the same bagTag.
      const q = query(
        collection(db, "users"),
        where("bagTag", "==", trimmedTag)
      );
      const querySnapshot = await getDocs(q);
      let duplicateFound = false;
      querySnapshot.forEach((docSnapshot) => {
        if (docSnapshot.id !== user.uid) {
          duplicateFound = true;
        }
      });
      if (duplicateFound) {
        setError("This Bag Tag is already taken.");
      } else {
        setError("");
        onChange(trimmedTag);
      }
    } catch (err) {
      console.error("Error checking Bag Tag:", err);
      setError("Error checking Bag Tag uniqueness.");
    }
  };

  const handleChange = (e) => {
    setBagTag(e.target.value);
    // Clear any existing error for re-validation.
    setError("");
  };

  return (
    <TextField
      label="Bag Tag"
      type="text"
      value={bagTag}
      onChange={handleChange}
      onBlur={handleBlur}
      fullWidth
      margin="normal"
      error={Boolean(error)}
      helperText={error || "A fancy way for people to identify you"}
      InputLabelProps={{
        sx: {
          whiteSpace: "normal",
          overflow: "visible",
          textOverflow: "unset",
        },
      }}
    />
  );
};

export default BagTag;